import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { Employer } from '../../employers/employer.interface';

export class EmployerService {
   async getEmployers(tenantId: number, params?: LocationQuery) {
      const response = await http.get<ApiResource<Array<Employer>>>(`/tenants/${tenantId}/employers`, { params });
      return response.data;
   }

   async getEmployer(tenantId: number, employerId: number) {
      const response = await http.get<ApiResource<Employer>>(`/tenants/${tenantId}/employers/${employerId}`);
      return response.data.data;
   }

   async postEmployer(tenantId: number, employer: Employer) {
      const response = await http.post<ApiResource<Employer>>(`/tenants/${tenantId}/employers`, employer);
      return response.data.data;
   }

   async putEmployer(tenantId: number, employerId: number, employer: Employer) {
      const response = await http.put<ApiResource<Employer>>(`/tenants/${tenantId}/employers/${employerId}`, employer);
      return response.data.data;
   }

   async deleteEmployer(tenantId: number, employerId: number) {
      const response = await http.delete(`/tenants/${tenantId}/employers/${employerId}`);
      return response.data;
   }

   async postEmployerLogo(tenantId: number, employerId: number, logo: File) {
      const formData = new FormData();
      formData.append('logo', logo);

      const response = await http.post(`/tenants/${tenantId}/employers/${employerId}/logo`, formData);
      return response.data;
   }
}
